// Pure helpers for the Bulk Attendee Fix "Download errors CSV" (client-side only).
// No PII beyond the owner-submitted correction rows; formula-injection safe.

const FORMULA = /^[=+\-@\t\r]/;
const NUMBER = /^-?\d+(\.\d+)?$/;

export function sanitizeCsvCell(value) {
  let str = value == null ? "" : String(value);
  if (FORMULA.test(str) && !NUMBER.test(str)) str = "'" + str;
  if (/[",\n\r]/.test(str)) str = '"' + str.replace(/"/g, '""') + '"';
  return str;
}

// Rows that need attention: preview invalid/conflict (never applied) +
// apply-time failed / resend_failed (joined back to submitted values by id).
export function buildBulkErrorRows(previewRows = [], resultRows = []) {
  const byId = {};
  previewRows.forEach((r) => { if (r.ticket_id) byId[r.ticket_id] = r; });
  const errs = [];
  previewRows.forEach((r) => {
    if (r.status === "invalid" || r.status === "conflict") {
      errs.push({ ticket_code: r.ticket_code, attendee_name: r.new_name,
        attendee_email: r.new_email, status: r.status, reason: r.reason });
    }
  });
  resultRows.forEach((r) => {
    const p = byId[r.ticket_id] || {};
    if (r.status === "failed") {
      errs.push({ ticket_code: p.ticket_code, attendee_name: p.new_name,
        attendee_email: p.new_email, status: "failed", reason: r.reason || "Update failed" });
    } else if (r.status === "changed" && r.resent === false && (r.reason || "").includes("resend failed")) {
      errs.push({ ticket_code: p.ticket_code, attendee_name: p.new_name,
        attendee_email: p.new_email, status: "resend_failed",
        reason: "Attendee updated but ticket email could not be sent" });
    }
  });
  return errs;
}

export const BULK_ERROR_HEADERS = ["ticket_code", "attendee_name", "attendee_email", "status", "reason"];

export function buildBulkErrorsCsv(previewRows = [], resultRows = []) {
  const rows = buildBulkErrorRows(previewRows, resultRows);
  const matrix = [BULK_ERROR_HEADERS, ...rows.map((r) => [
    r.ticket_code, r.attendee_name, r.attendee_email, r.status, r.reason,
  ])];
  return matrix.map((row) => row.map(sanitizeCsvCell).join(",")).join("\r\n");
}
